<template>
    <div class="page main">
        <TheHeroSection
            :title="contents[1].title"
            :hero-blurp="contents[1].blurp"
            :raw-image-src="contents[1].img.src"
            :button-text="contents[1].button.text"
            />
        
        <div class="content">
        
            <section class="default">
                <h2 class="title section--header">Slow Children At Play Info, Offers & Ressources</h2>
                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate in sit deleniti, autem minima, saepe fugit dignissimos amet optio ipsa doloribus repudiandae qui quidem aperiam assumenda nesciunt eius, nulla animi.
                </p>
            </section>

            <section class="default gap">
                <img :src="require(`@/assets/background/bash.webp`)" alt="">
            </section>

            <section class="default infogrid">
                <div class="grid__title title">Grid Title</div>
                <div class="grid__item">Item 1</div>
                <div class="grid__item">Item 2</div>
                <div class="grid__item">Item 3</div>
                <div class="grid__item">Item 4</div>
                <div class="grid__item">Item 5</div>
                <div class="grid__item">Item 6</div>
            </section>

            <section class="default gap" />

            <section class="side-media">
                <div class="media__text">
                    <div class="media--title title">Media Title</div>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis ea vero tempore tempora ipsum aliquid fuga corrupti. Ipsam minima impedit tempora laboriosam voluptatum. Blanditiis velit esse error laudantium dolores ut?
                    </p>
                </div>
                <div class="media__image">
                    <img :src="require(`@/assets/background/panther.webp`)" alt="">
                </div>
            </section>

            <section class="side-media reverse">
                <div class="media__text">
                    <div class="media--title title">Media Title</div>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis ea vero tempore tempora ipsum aliquid fuga corrupti. Ipsam minima impedit tempora laboriosam voluptatum. Blanditiis velit esse error laudantium dolores ut?
                    </p>
                </div>
                <div class="media__image">
                    <img :src="require(`@/assets/background/bash.webp`)" alt="">
                </div>
            </section>

            <section class="default gap" />

            <section class="default infogrid">
                <div class="grid__title title">Grid Title</div>
                <div class="grid__item">Item 1</div>
                <div class="grid__item">Item 2</div>
                <div class="grid__item">Item 3</div>
                <div class="grid__item">Item 4</div>
                <div class="grid__item">Item 5</div>
                <div class="grid__item">Item 6</div>
            </section>

            <section class="default gap" />

            <section class="default" />

            <TheFooterSection />
        
        </div>
        
    </div>
</template>

<script>
import TheHeroSection from '@/components/TheHeroSection.vue';
import TheFooterSection from '@/components/TheFooterSection.vue';

export default {
    props: {
        contents: Array
    },
    components: { TheHeroSection, TheFooterSection },
    computed: {
        
    }
}
</script>